import { useRef, useLayoutEffect } from "react";

const useLatestValue = value => {
  const latestValueRef = useRef(value);

  useLayoutEffect(() => {
    latestValueRef.current = value;
  }, [value]);

  return latestValueRef;
};

export default useLatestValue;
